export default function(context) {
  if (process.server) {
    // const req = context.req
    // const res = context.res
    // console.log(`${req.method} ${req.url} ${res.statusCode}`)
  }
}
